import { useEffect, useState } from "react";
import { Token, URL_API } from "../../utils/Constant";
import axios from "axios";
import { toast } from "react-toastify";

interface AutresIterface {
    [key: string]: any;
}

const useAutresListe = (refresh: boolean): AutresIterface[] => {
    const [autres, setAutres] = useState<AutresIterface[]>([]);

    useEffect(() => {
        const fetchAutres = async () => {
            axios.get(`${URL_API}/autres-index`, {
                headers: {
                    Authorization: `Bearer ${Token}`
                }
            }).then(response => {

                if (response.status == 200) {
                    setAutres(response.data.autres);
                }

            }).catch(error => {
                if (error.status === 400) {
                    toast.info(error.data.message);
                }

                if (error.status === 500) {
                    toast.warning(error.data.message);
                }
            })
        };

        fetchAutres();
    }, [refresh]);
    return autres;
};

export default useAutresListe;

export const deleteUsers = async ({ id }: { id: number }, onSuccess: () => void) => {

    axios.get(`${URL_API}/autres-destroy/${id}`, {
        headers: {
            Authorization: `Bearer ${Token}`
        }
    }).then(response => {

        if (response.status === 200) {
            toast.warning(response.data.message)
            onSuccess();
        }

    }).catch(error => {
        if (error.status === 405) {
            toast.info(error.response.data.message)
        }
    })

}

export const changeStatus = ({ id }: { id: number }, onSuccess: () => void) => {
    axios.get(`${URL_API}/admin/changeStatus/${id}`, {
        headers: {
            Authorization: `Bearer ${Token}`
        }
    }).then(response => {

        if (response.status === 200) {
            toast.warning(response.data.message)
            onSuccess();
        }

    }).catch(error => {
        if (error.status === 405) {
            toast.info(error.response.data.message)
        }
    })
}

